import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TPVServices } from "../../../services";
import { Globals } from "../../../../../globals";
import { ConfigurationServices } from '../../../../configuration/services';

/**
 * Generated class for the TpvTicketSelectedPayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-ticket-discount-restaurantticket',
  templateUrl: 'tpv-ticket-discount-restaurantticket.html',
})
export class TpvTicketDiscountRestaurantticketPage {
  type: any;
  percentage: any = 0;
  total: any = 0;
  valor: any = 0;
  discounted: any = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    public configurationServices: ConfigurationServices) {
    this.type = this.navParams.get('type');

    this.total = tpvServices.totalTicketSelected(tpvServices.selected_table_tpv_index);

  }

  back() {
    this.navCtrl.pop();
  }

  applyDiscount(number) {
    this.percentage = number;
    //calculate
    this.calculate();
  }

  onchangeDiscount() {
    this.calculate();
  }

  calculate() {
    this.total = this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index);
    this.discounted = (this.total * this.percentage) / 100;
    this.total = this.total - this.discounted;
  }

  restart() {
    this.percentage = 0;
    this.valor = 0;
    this.discounted = 0;
    this.total = this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index);
  }

  onChange() {
    this.total = this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index);
    this.total = this.total - this.valor;
  }

  saveDiscounts() {
    var name = '';
    if (this.type == 'discount') {
      name = 'Descuento ' + this.percentage + '%';
      this.tpvServices.insertTableDiscount(name, -Math.abs(this.discounted), false, true, 'discount', '', 'discount', this.discounted, this.globals.RESTAURANT_TAX);
      this.tpvServices.deleteKeyboard();
      this.navCtrl.pop();
      this.navCtrl.pop();

    } else {
      name = 'Ticket restaurante ' + this.valor + '' + this.globals.currency_symbol;
      this.tpvServices.insertTableDiscount(name, -Math.abs(this.valor), false, true, 'restaurant_ticket', '', 'restaurant_ticket', this.valor, this.globals.RESTAURANT_TAX);
      this.tpvServices.deleteKeyboard();
      this.navCtrl.pop();
      this.navCtrl.pop();
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-discount-restaurantticket/tpv-ticket-discount-restaurantticket.ts